import photo from 'src/assets/images/image28.png';
import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { Typography, PrimaryButton } from '@weareopenr/component-library';
import styles from './Welcome.module.scss';
import { useAuthWrapper } from '@weareopenr/authkit';

const Welcome = () => {
  const { user, signIn } = useAuthWrapper();

  useEffect(() => {
    document.title = 'Welcome';
  }, []);

  const login = async () => {
    await signIn();
  };

  if (user) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className={styles.container}>
      <div className={styles.left}>
        <div className={styles['login-container']}>
          <Typography size="xxlarge" weight="semi-bold" className={styles.text}>
            Welcome back
          </Typography>
          <PrimaryButton size="full-width" onClick={login}>
            Login
          </PrimaryButton>
        </div>
      </div>
      <div className={styles.right}>
        <img src={photo} className={styles.image} alt="People in a restaurant" />
      </div>
    </div>
  );
};

export default Welcome;
